<template>
    <div class="wx">
        <div class="content">

                <div v-for="post in WR_Json_Data.LIST_USED_AIRPORTS" :key="post.idx">

                    <div v-if="post.WeatherText != null">
                        <pre> {{post.WeatherText}} </pre>
                    </div>

                    <div v-else-if="post.WeatherText == '' && post.AirportIcao != ''">
                        <pre> <span style="color: red">{{post.AirportIcao}} : weather data not found. </span> </pre>
                    </div>

                </div>


        </div>
    </div>
</template>

<script>
    import {loadingMixin} from "../../../../utils/mixins";
    // "EFF_Json_Data","WR_Json_Data"
    import {mapState} from "vuex";
    export default
    {
        name: "WX",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        data() {
            return {

            }
        },

        computed : {
            ...mapState("ipadmain",[/*"FKey1",*/ "selectedFlightItems","EFF_Json_Data","WR_Json_Data"]),
            // getPdfStreamUrl:{
            //
            //     get(){
            //         return this.flightReleaseUrl + '?FKey1=' + this.flight.fKey1;
            //     },
            //     set()
            //     {
            //
            //     }
            //
            // }

    }
    }
</script>

<style scoped>
    .content {
        height: 900px;
        width: 100%;
    }

    .title {
        margin-bottom: 0;
    }
</style>
